// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__16CMf","shimmer":"styles_shimmer__36OeB"};